import { GenericObject, copyFields } from '@synergy/models';

import { Contact } from '../../../common/models/contact';
import { Customer } from '../../../common/models/customer';

export class DemandCustomer {
    public id!: number;
    public emailSentDate?: Date;
    public account!: Customer;
    public contact?: Contact;

    public static fromPlainObject(object: GenericObject): DemandCustomer {
        const demandCustomer = new DemandCustomer();

        copyFields(object, demandCustomer);

        if (object['account']) {
            demandCustomer.account = Customer.fromPlainObject(object['account']);
        }

        if (object['contact']) {
            demandCustomer.contact = Contact.fromPlainObject(object['contact']);
        }

        return demandCustomer;
    }
}
